<template>
  <nav
    id="navbar"
    class="navbar is-fixed-top"
    :class="{ 'is-black': $chain !== 'mq' }"
    :style="
      $chain === 'mq'
        ? { backgroundColor: '#133b23' }
        : $chain === 'brmania'
        ? { backgroundColor: '#3A8349' }
        : null
    "
    role="navigation"
    aria-label="main navigation"
  >
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <!-- Navbar Brand -->
    <div class="navbar-brand">
      <figure class="image">
        <router-link to="dashboard" v-if="$chain === 'mq'">
          <img
            id="logo-navbar-mq"
            src="../../assets/img/logo-mq-white.png"
            alt="Logo Minha Quitandinha"
            title="Minha Quitandinha"
          />
        </router-link>

        <router-link to="dashboard" v-else-if="$chain === 'brmania'">
          <img
            id="logo-navbar-brmania"
            src="../../assets/img/logo-brmania-branco.png"
            alt="Logo BR Mania"
            title="BR Mania"
            style="max-width: 150px; position: relative; top: 6px; left: 10px"
          />
        </router-link>

        <router-link to="dashboard" v-else>
          <img
            id="logo-navbar"
            src="../../assets/img/logo-smart-orange-outline.png"
            alt="Logo Onii | Conveniência Autônoma"
            title="Onii - Conveniência Autônoma"
          />
        </router-link>
      </figure>

      <div
        v-if="shouldShowRewardBadge"
        class="navbar-item reward-badge-wrapper reward-badge-wrapper-mobile"
      >
        <router-link
          to="/reward-program"
          class="reward-badge reward-badge-link"
          @click.native="showNavbarMenu = false"
        >
          <img
            v-if="formattedRewardLevel"
            :src="rewardBadgeImage"
            :alt="`Badge ${formattedRewardLevel}`"
            class="reward-badge-image"
          />

          <div class="reward-badge-text">
            <span class="reward-badge-level">
              {{ formattedRewardLevel }}
            </span>

            <span class="reward-badge-points">
              {{ formattedRewardPoints }}
            </span>
          </div>
        </router-link>
      </div>

      <div
        role="button"
        id="navbar-burger"
        class="navbar-burger"
        :class="{ 'is-active': showNavbarMenu }"
        data-target="navMenu"
        aria-label="menu"
        aria-expanded="false"
        @click="showNavbarMenu = !showNavbarMenu"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </div>
    </div>

    <!-- Navbar Menu -->
    <div
      class="navbar-menu"
      :class="{ 'is-active': showNavbarMenu }"
      id="navMenu"
      v-if="showMenu"
    >
      <div class="navbar-end">
        <!-- <timezone-indicator /> -->

        <div
          v-if="shouldShowRewardBadge"
          class="navbar-item reward-badge-wrapper reward-badge-wrapper-desktop"
        >
          <router-link
            to="/reward-program"
            class="reward-badge reward-badge-link"
          >
            <img
              v-if="formattedRewardLevel"
              :src="rewardBadgeImage"
              :alt="`Badge ${formattedRewardLevel}`"
              class="reward-badge-image"
            />

            <div class="reward-badge-text">
              <span class="reward-badge-level">
                {{ formattedRewardLevel }}
              </span>

              <span class="reward-badge-points">
                {{ formattedRewardPoints }}
              </span>
            </div>
          </router-link>
        </div>

        <div class="navbar-item has-dropdown is-hoverable">
          <div
            id="username"
            :style="$chain === 'mq' ? { color: '#fff' } : null"
          >
            <span
              class="flag flag-icon language-flags"
              :class="
                locale === 'pt_BR'
                  ? 'flag-icon-br'
                  : locale === 'pt_PT'
                  ? 'flag-icon-pt'
                  : locale === 'en'
                  ? 'flag-icon-gb'
                  : locale === 'es'
                  ? 'flag-icon-es'
                  : ''
              "
              @click="isLanguageModalActive = true"
            >
            </span>

            <span v-if="role === 'operator' && operatorInfo">
              {{ `${operatorInfo.name}` }}
            </span>

            <span v-else>
              {{ `${ownerInfo.name} ${ownerInfo.surname}` }}
            </span>
          </div>
          <b-icon id="angle-down" icon="angle-down" type="is-white"></b-icon>

          <b-modal :active.sync="isLanguageModalActive">
            <language-modal />
          </b-modal>

          <div class="navbar-dropdown">
            <router-link
              to="/purchases"
              class="navbar-item"
              v-if="
                stores.length > 0 &&
                  permissions.seePurchases &&
                  !onlyCacauShowVendings
              "
            >
              {{ $t("dashboard.purchases") }}
            </router-link>

            <router-link
              :to="{ path: '/transactions', query: { allStores: 'true' } }"
              class="navbar-item"
              v-if="stores.length > 0 && permissions.seeTransactionsPage"
            >
              {{ $t("transactions.transactions") }}
            </router-link>

            <router-link
              :to="{ path: '/accesses', query: { allStores: 'true' } }"
              class="navbar-item"
              v-if="stores.length > 0 && permissions.seeAccessesPage"
            >
              {{ $t("dashboard.accesses") }}
            </router-link>

            <router-link
              :to="{ path: '/feedbacks', query: { allStores: 'true' } }"
              class="navbar-item"
              v-if="stores.length > 0 && permissions.seeFeedbacksPage"
            >
              {{ $t("dashboard.feedbacks") }}
            </router-link>

            <!-- <router-link to="/scale-products" class="navbar-item">
              {{ $t("dashboard.scaleProducts") }}
            </router-link> -->

            <router-link
              to="/monitoring"
              class="navbar-item"
              v-if="
                openMart &&
                  openMart.status &&
                  merchantHasOpenMartCameraMonitoring
              "
            >
              {{ $t("dashboard.monitoring") }}
            </router-link>

            <router-link
              to="/clients"
              class="navbar-item"
              v-if="
                stores.length > 0 && permissions.seeClients && !onlyVendings
              "
            >
              {{ $t("dashboard.clients") }}
            </router-link>

            <router-link
              to="/users"
              class="navbar-item"
              v-if="
                stores.length > 0 &&
                  permissions.seeBlockedClients &&
                  !onlyVendings
              "
            >
              {{ $t("dashboard.blockedUsers") }}
            </router-link>

            <router-link
              to="/stockouts"
              class="navbar-item"
              v-if="
                stores.length > 0 && permissions.seeStockouts && !onlyVendings
              "
            >
              {{ $t("dashboard.stockouts") }}
            </router-link>

            <router-link
              to="/buy-now-pay-later"
              class="navbar-item"
              v-if="merchantHasBuyNowPayLater && !onlyVendings"
            >
              <!-- TODO: adicionar permissão de usuário -->
              {{ $t("dashboard.buyNowPayLater") }}
            </router-link>

            <router-link
              to="/reward-program"
              class="navbar-item"
              v-if="canSeeRewardProgram"
            >
              {{ $t("dashboard.rewardProgram") }}
            </router-link>

            <router-link
              to="/settlements"
              class="navbar-item"
              v-if="stores.length > 0 && permissions.seeSettlements"
            >
              {{ $t("dashboard.settlements") }}
            </router-link>

            <router-link
              to="/credits"
              class="navbar-item"
              v-if="
                stores.length > 0 && permissions.seeCashbacks && !onlyVendings
              "
            >
              {{ $t("dashboard.credits") }}
            </router-link>

            <router-link
              to="/pending-external-products"
              class="navbar-item"
              v-if="
                stores.length > 0 &&
                  permissions.createProducts &&
                  !onlyCacauShowVendings
              "
            >
              {{ $t("dashboard.pendingProducts") }}
            </router-link>

            <router-link
              to="/product-logs"
              class="navbar-item"
              v-if="
                canSeeProductLogs &&
                  stores.length > 0 &&
                  permissions.seeRefillsAndInventories
              "
            >
              {{ $t("refillsStock.title") }}
            </router-link>

            <router-link to="/dashboard" class="navbar-item">
              {{ $t("dashboard.dashboard") }}
            </router-link>

            <router-link to="/stores" class="navbar-item">
              {{ $tc("dashboard.stores", 2) }}
            </router-link>

            <router-link
              v-if="lockers.length > 0"
              to="/lockers"
              class="navbar-item"
            >
              {{ $tc("dashboard.lockers", lockers.length) }}
            </router-link>

            <hr class="navbar-divider" />

            <router-link
              to="/operators"
              class="navbar-item"
              v-if="permissions.manageOperators"
            >
              {{ $t("dashboard.operators") }}
            </router-link>

            <router-link
              to="/vending-categories"
              class="navbar-item"
              v-if="merchantHasVendings && !onlyCacauShowVendings"
            >
              <!-- TO DO adicionar permissão -->
              {{ $t("dashboard.vendingCategories") }}
            </router-link>

            <router-link
              to="/product-creation"
              class="navbar-item"
              v-if="
                stores.length > 0 &&
                  permissions.createProducts &&
                  !onlyCacauShowVendings
              "
            >
              {{ $t("dashboard.createProducts") }}
            </router-link>

            <router-link to="/account" class="navbar-item">
              {{ $t("dashboard.accountConfiguration") }}
            </router-link>

            <router-link
              v-if="!onlyCacauShowVendings"
              to="/purchases-invoices"
              class="navbar-item"
            >
              {{ $t("dashboard.purchasesInvoices") }}
            </router-link>

            <router-link
              v-if="!onlyCacauShowVendings"
              to="/invoices-pack"
              class="navbar-item"
            >
              {{ $t("dashboard.invoicesPack") }}
            </router-link>

            <router-link
              to="/billing"
              class="navbar-item"
              v-if="permissions.seeBilling"
            >
              {{ $t("dashboard.billing") }}
            </router-link>

            <!-- <router-link
              v-if="!onlyCacauShowVendings"
              to="/courses"
              class="navbar-item"
            >
              {{ $t("dashboard.courses") }}
            </router-link> -->

            <a
              v-if="!onlyCacauShowVendings"
              :href="
                $chain === 'mq'
                  ? 'https://minhaquitandinha.sults.com.br/'
                  : 'https://onii.notion.site/Merchant-Gest-o-da-sua-loja-2cbff19e7c69807fabb5d26a9f413ab1?source=copy_link'
              "
              class="navbar-item"
              target="_blank"
            >
              {{ $t("dashboard.support") }}
            </a>

            <span>
              <hr class="navbar-divider" />

              <router-link to="/ferramentas" class="navbar-item">
                {{ $t("dashboard.tools") }}
              </router-link>
            </span>

            <a
              v-if="onlyCacauShowVendings"
              href="https://assets.onii.app/documents/Manual+Merchant+%2B+Vending+%2B+Re%CC%81gua+Smart+v3.pdf"
              class="navbar-item"
              target="_blank"
            >
              {{ $t("dashboard.cacauManuals") }}
            </a>

            <hr class="navbar-divider" />

            <a class="navbar-item" @click="logout">
              {{ $t("common.logout") }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import languageModal from "../account/LanguageModal";
import badgeBlack from "../../assets/img/badges/badge-black.png";
import badgeDiamond from "../../assets/img/badges/badge-diamond.png";
import badgeGold from "../../assets/img/badges/badge-gold.png";
import badgeInfinity from "../../assets/img/badges/badge-infinity.png";
import badgePlatinum from "../../assets/img/badges/badge-platinum.png";
import badgeSilver from "../../assets/img/badges/badge-silver.png";
import badgeStart from "../../assets/img/badges/badge-start.png";
import {
  canAccessProductLogs,
  PRODUCT_LOGS_NETWORK_RELEASE_AT
} from "../../utils/pilotFeatures";
// import timezoneIndicator from "./TimezoneIndicator";

export default {
  mixins: [common],

  data() {
    return {
      isLoading: false,
      showNavbarMenu: false,
      isLanguageModalActive: false,
      productLogsAvailabilityTime: Date.now(),
      productLogsReleaseTimer: null
    };
  },

  props: {
    showMenu: {
      type: Boolean,
      default: true
    }
  },

  components: {
    languageModal
    // timezoneIndicator
  },

  methods: {
    setLocale(l) {
      this.$store.dispatch("setLocale", l);
    },

    loadMenuData() {
      const requests = [];

      if (!this.ownerInfo.email) {
        requests.push(this.$store.dispatch("getAccountData"));
      }

      if (!this.stores.length) {
        requests.push(this.$store.dispatch("getStores"));
      }

      if (!this.lockers.length) {
        requests.push(this.$store.dispatch("getLockers"));
      }

      if (!requests.length) {
        return Promise.resolve([]);
      }

      return Promise.all(requests);
    },

    checkDevelopmentEnvironment() {
      return (
        document.URL.indexOf("stage.merchant.onii.app") > -1 ||
        document.URL.indexOf("localhost") > -1
      );
    }
  },

  computed: {
    ...mapGetters([
      "ownerInfo",
      "locale",
      "stores",
      "lockers",
      "permissions",
      "role",
      "operatorInfo",
      "merchantHasBuyNowPayLater",
      "merchantHasOpenMartCameraMonitoring",
      "merchantHasVendings",
      "onlyVendings",
      "onlyCacauShowVendings",
      "openMart",
      "companyInfo",
      "rewardProgram"
    ]),

    shouldShowRewardBadge() {
      return (
        this.canSeeRewardProgram &&
        this.rewardBadgeImage &&
        this.formattedRewardLevel
      );
    },

    canSeeRewardProgram() {
      return ["oniiFranchise", "mq"].includes(this.companyInfo.contract);
    },

    canSeeProductLogs() {
      return canAccessProductLogs(
        this.ownerInfo,
        this.productLogsAvailabilityTime
      );
    },

    rewardBadgeImage() {
      const currentLevel = (
        this.rewardProgram.currentLevel || ""
      ).toLowerCase();

      const badgeImages = {
        black: badgeBlack,
        diamond: badgeDiamond,
        gold: badgeGold,
        infinity: badgeInfinity,
        platinum: badgePlatinum,
        silver: badgeSilver,
        start: badgeStart
      };

      return badgeImages[currentLevel] || null;
    },

    formattedRewardLevel() {
      const currentLevel = this.rewardProgram.currentLevel || "";

      if (!currentLevel) {
        return "";
      }

      return currentLevel.charAt(0).toUpperCase() + currentLevel.slice(1);
    },

    formattedRewardPoints() {
      if (!this.formattedRewardLevel) {
        return "";
      }

      return `${this.rewardProgram.points || 0} pts`;
    }
  },

  mounted() {
    const productLogsReleaseDelay =
      PRODUCT_LOGS_NETWORK_RELEASE_AT - this.productLogsAvailabilityTime;
    if (productLogsReleaseDelay > 0) {
      this.productLogsReleaseTimer = setTimeout(() => {
        this.productLogsAvailabilityTime = Date.now();
      }, productLogsReleaseDelay);
    }

    if (this.showMenu) {
      this.isLoading = true;
      this.loadMenuData()
        .then(res => {
          res.forEach(response => {
            if (response.data.result === "error") {
              this.alertError(response.data);
            }
          });
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }

    let didScroll;
    let lastScrollTop = 0;
    /* defined in DOMContentLoaded event */
    let navbarHeight = document.getElementById("navbar").scrollHeight + 4;

    /* on scroll, let the interval function know the user has scrolled */
    window.addEventListener("scroll", function() {
      didScroll = true;
    });

    /* run hasScrolled() and reset didScroll status */
    setInterval(function() {
      if (didScroll) {
        let scrollTop =
          document.body.scrollTop + document.documentElement.scrollTop;

        if (scrollTop > 20 && scrollTop > lastScrollTop) {
          document.getElementById("navbar").style.marginTop =
            -navbarHeight + "px";
        } else {
          document.getElementById("navbar").style.marginTop = 0;
        }

        lastScrollTop = scrollTop;

        didScroll = false;
      }
    }, 50);
  },

  beforeDestroy() {
    if (this.productLogsReleaseTimer) {
      clearTimeout(this.productLogsReleaseTimer);
    }
  }
};
</script>

<style scoped>
#logo-navbar {
  margin-top: 6px;
  margin-left: 50px;
  width: 72px !important;
  cursor: pointer;
}
#logo-navbar-mq {
  margin-top: 6px;
  margin-left: 50px;
  width: 140px !important;
  cursor: pointer;
}
@media (max-width: 425px) {
  #logo-navbar {
    margin-left: 25px;
  }
  #logo-navbar-mq {
    margin-left: 25px;
  }
}
@media (max-width: 1024px) {
  #username {
    margin-left: 1.5rem;
  }
}
#navMenu > div:last-child {
  margin-right: 50px;
}
.navbar-item.has-dropdown.is-hoverable {
  align-items: center;
}
.navbar-burger {
  color: white;
}
.navbar-burger:hover {
  color: #ccc;
}
.language-flags {
  margin-right: 5px;
  cursor: pointer;
}
#username {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.reward-badge {
  display: flex;
  align-items: center;
  gap: 0.1rem;
}
.reward-badge-link {
  color: inherit;
  text-decoration: none;
}
.reward-badge-wrapper {
  padding-right: 0;
  margin-right: 2rem;
}
.reward-badge-wrapper-mobile {
  display: none;
  margin-left: auto;
  margin-right: 0.25rem;
  padding: 0;
}
.reward-badge-wrapper-mobile .reward-badge {
  gap: 0.35rem;
}
.reward-badge-image {
  width: 40px;
  height: 40px;
  object-fit: contain;
  flex-shrink: 0;
}
.reward-badge-text {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
  color: #fff;
}
.reward-badge-level {
  font-size: 0.85rem;
  font-weight: 700;
}
.reward-badge-points {
  font-size: 0.75rem;
  opacity: 0.9;
}
#angle-down {
  padding-left: 1rem;
}
/* @media screen and (min-width: 1023px) {
  .navbar-dropdown {
    left: -50px;
  }
} */
#navbar {
  -webkit-transition: 0.25s all ease-in-out;
  -moz-transition: 0.25s all ease-in-out;
  -o-transition: 0.25s all ease-in-out;
  transition: 0.25s all ease-in-out;
  z-index: 10000;
}
.navbar-menu {
  z-index: 10000;
}
.navbar-dropdown {
  z-index: 10001;
}

@media screen and (max-width: 1023px) {
  .reward-badge-wrapper-desktop {
    display: none;
  }

  .reward-badge-wrapper-mobile {
    display: flex;
    align-items: center;
  }

  .reward-badge-wrapper-mobile .reward-badge-image {
    width: 32px;
    height: 32px;
  }

  .reward-badge-wrapper-mobile .reward-badge-level {
    font-size: 0.75rem;
  }

  .reward-badge-wrapper-mobile .reward-badge-points {
    font-size: 0.65rem;
  }

  #navMenu.navbar-menu {
    max-height: calc(100vh - 3.25rem);
    max-height: calc(100dvh - 3.25rem);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    padding-bottom: max(1.5rem, env(safe-area-inset-bottom, 0px));
    scroll-padding-bottom: max(1.5rem, env(safe-area-inset-bottom, 0px));
  }

  #username {
    flex-wrap: wrap;
    row-gap: 0.5rem;
  }

  .reward-badge-wrapper {
    padding-bottom: 0;
  }
}

@media screen and (min-width: 1024px) {
  .reward-badge-wrapper-mobile {
    display: none;
  }

  #navMenu .navbar-dropdown {
    max-height: calc(100vh - 2rem);
    max-height: calc(100dvh - 2rem);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    padding-bottom: 1.5rem;
    scroll-padding-bottom: 1.5rem;
  }
}
</style>
